import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "contexts/AuthContext";
import AuthService from "services/auth.service";

const Check = ({ children }) => {
  const { user, isLoggedIn, isLoading } = useAuth();
  
  // Show loading while auth is being initialized
  if (isLoading) {
    return <div>Loading...</div>;
  }
  
  // If no user or not logged in, redirect to login
  if (!isLoggedIn) {
    return <Navigate to="/" replace />;
  }
  
  return children;
};

export default Check;
